const page_schema = {
	"tiers": [
		{
			"name": "Target",
			"type": "checkbox",
			"id": "targets",
			"class_name": "tags",
			"child_name": "target",
			"options": [
				{
					"name": "5mC",
					"id": "5mc"
				},
				{
					"name": "5hmC",
					"id": "5hmc"
				},
				{
					"name": "Chromatin",
					"id": "chromatin"
				},
				{
					"name": "Methylation: Whole Genome",
					"id": "methylation:-whole-genome"
				},
				{
					"name": "Methylation: Reduced Representation",
					"id": "methylation:-reduced-representation"
				},
				{
					"name": "Bisulfite",
					"id": "bisulfite"
				},
				{
					"name": "Non Bisulfite",
					"id": "non-bisulfite"
				},
				{
					"name": "Whole Genome DNA-Seq",
					"id": "whole-genome-dna-seq"
				},
			]
		},
		{
			"name": "Formats",
			"type": "checkbox",
			"id": "formats",
			"class_name": "tags",
			"child_name": "format",
			"options": [
				{
					"name": "10 Preps",
					"id": "10-preps"
				},
				{
					"name": "12 Preps",
					"id": "12-preps"
				},
				{
					"name": "24 Preps",
					"id": "24-preps"
				},
				{
					"name": "25 Preps",
					"id": "25-preps"
				},
				{
					"name": "48 Preps",
					"id": "48-preps"
				},
				{
					"name": "96 Preps",
					"id": "96-preps"
				},
			]
		},
		{
			"name": "Features",
			"type": "checkbox",
			"id": "features",
			"class_name": "tags",
			"child_name": "feature",
			"options": [
				{
					"name": "Compatible with Zymo-Seq UDI Primers",
					"id": "compatible-with-zymo-seq-udi-primers"
				},
				{
					"name": "Low Input",
					"id": "low-input"
				},
			]
		},
	],
	"filters": [],
	"products": {
		"Zymo-Seq Trio WGBS Library Kit": {
			"title": "Zymo-Seq Trio WGBS Library Kit",
			"catalogNumbers": "D5462, D5463",
			"description": "The Zymo-Seq Trio WGBS Library Kit offers an optimized and reliable workflow for whole genome bisulfite sequencing (WGBS) library preparation from cell-free DNA (cfDNA), FFPE DNA, and gDNA. ",
			"handle": "/products/zymo-seq-trio-wgbs-library-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5462_Zymo-Seq-Cell-Free-DNA-WGBS-Library-Kit.jpg?v=1642623540&width=600",
			"generalIndex": "998",
			"id": "zymo-seq-trio-wgbs-library-kit",
			"tags": [
				"5mc",
				"methylation:-whole-genome",
				"bisulfite",
				"24-preps",
				"96-preps",
				"compatible-with-zymo-seq-udi-primers",
			],
			filters: []
		},
		"Zymo-Seq WGBS Library Kit": {
			"title": "Zymo-Seq WGBS Library Kit",
			"catalogNumbers": "D5465",
			"description": "Zymo-Seq WGBS Library Kit is the only kit available for whole genome bisulfite (WGBS) library preparation in a single tube. The Kit incorporates tagmentation technology to eliminate the tedious fragmentation, enzymatic, and clean-up steps required by conventional, ligation-based library preparation methods. Reproducible genome coverage from any species (>90% of CpG sites detected in mammalian samples)",
			"handle": "/products/zymo-seq-wgbs-library-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d5465-zymo_seq_wgbs_library_kit.jpg?v=1628632445&width=600",
			"generalIndex": "998",
			"id": "zymo-seq-wgbs-library-kit",
			"tags": [
				"5mc",
				"methylation:-whole-genome",
				"bisulfite",
				"24-preps",
			],
			filters: []
		},
		"Zymo-Seq RRBS Library Kit": {
			"title": "Zymo-Seq RRBS Library Kit",
			"catalogNumbers": "D5460, D5461",
			"description": "Zymo-Seq RRBS Library Kit is an all-in-one RRBS library prep kit that generates NGS libraries with a simplified workflow for the classic method Reduced Representation Bisulfite Sequencing (RRBS). This all-in-one RRBS library prep kit allows for DNA methylation profiling at single-nucleotide resolution in CpG-rich regions of the genome.",
			"handle": "/products/zymo-seq-rrbs-library-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d5460_ez_dna_methylation_rrbs_library_prep_kit_3045e660-6901-4f39-bdf2-0a00421995b9.png?v=1628706203&width=600",
			"generalIndex": "998",
			"id": "zymo-seq-rrbs-library-kit",
			"tags": [
				"5mc",
				"methylation:-reduced-representation",
				"bisulfite",
				"24-preps",
				"48-preps",
				"compatible-with-zymo-seq-udi-primers",
			],
			filters: []
		},
		"Pico Methyl-Seq Library Prep Kit": {
			"title": "Pico Methyl-Seq Library Prep Kit",
			"catalogNumbers": "D5455, D5456",
			"description": "The Pico Methyl-Seq Library Prep Kit provides a streamlined workflow for making WGBS libraries. Input DNA is randomly fragmented during the initial bisulfite treatment step followed by three rounds of amplification with uniquely designed primers. The procedure can accommodate as little as 10 pg input DNA (including that derived from FFPE samples), making it ideal for methylation analysis of precious, limited, and target-enriched samples.",
			"handle": "/products/pico-methyl-seq-library-prep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d5456_pico-methyl-seq-library-prep-kit_1.jpg?v=1628532385&width=600",
			"generalIndex": "998",
			"id": "pico-methyl-seq-library-prep-kit",
			"tags": [
				"5mc",
				"methylation:-whole-genome",
				"bisulfite",
				"10-preps",
				"25-preps",
				"compatible-with-zymo-seq-udi-primers",
				"low-input",
			],
			filters: []
		},
		"RRHP 5-hmC Library Prep Kit": {
			"title": "RRHP 5-hmC Library Prep Kit",
			"catalogNumbers": "D5450, D5451",
			"description": "The RRHP 5-hmC Library Prep Kit is an all-inclusive solution for analysis of genome-wide 5-hydroxymethylcytosine (5-hmC) positions at single-base resolution. The Reduced Representation Hydroxymethylation Profiling (RRHP) method is based on blocking MspI digestion by glucosylating 5-hmC within MspI recognition sites. Fragments lacking glucosylated 5-hmC at the adapter-ligation junction will be cleaved and not amplified by PCR. Therefore, only fragments containing 5-hmC will be successfully amplified and analyzed by Next-Generation Sequencing. ",
			"handle": "/products/rrhp-5-hmc-library-prep-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5450_RRHP_205-hmC_20Library_20Prep_20Kit.png?v=1628532403&width=600",
			"generalIndex": "998",
			"id": "rrhp-5-hmc-library-prep-kit",
			"tags": [
				"5hmc",
				"methylation:-reduced-representation",
				"non-bisulfite",
				"12-preps",
				"25-preps",
			],
			filters: []
		},
		"Zymo-Seq ATAC Library Kit": {
			"title": "Zymo-Seq ATAC Library Kit",
			"catalogNumbers": "D5458",
			"description": "Zymo-Seq ATAC Library Kit provides a simple and streamlined workflow for Assay for Transposase Accessible Chromatin with high throughput Sequencing (ATAC-Seq) library preparation from mammalian cell and tissue input. This all-inclusive kit features an easy to follow protocol capable of preparing ATAC-Seq libraries from as little as 50,000 cells in as little as 4 hours with minimal hands on time.",
			"handle": "/products/zymo-seq-atac-library-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/D5458-Zymo-Seq-ATAC-Library-Kit_2365_002_ProductPhoto.jpg?v=1677624838&width=600",
			"generalIndex": "998",
			"id": "zymo-seq-atac-library-kit",
			"tags": [
				"chromatin",
				"non-bisulfite",
				"12-preps",
			],
			filters: []
		},
		"Zymo-Seq SPLAT DNA Library Kit": {
			"title": "Zymo-Seq SPLAT DNA Library Kit",
			"catalogNumbers": "D5464",
			"description": "The Zymo-Seq™ SPLAT DNA Library Kit is a versatile solution for DNA library preparation from a wide variety of sample types. ",
			"handle": "/products/zymo-seq-splat-dna-library-kit",
			"navigation_image": "https://files.zymoresearch.com/product-images/d5464_zymo-seq_splat_dna_library_kit_(12_prep).jpg",
			"generalIndex": "998",
			"id": "zymo-seq-splat-dna-library-kit",
			"tags": [
				"whole-genome-dna-seq",
				"12-preps",
				"compatible-with-zymo-seq-udi-primers",
			],
			filters: []
		},
		"Zymo-Seq UDI Primer Sets": {
			"title": "Zymo-Seq UDI Primer Sets",
			"catalogNumbers": "D3008, D3096, D3097, D3098",
			"description": "The Zymo-Seq UDI Primer Sets contain pre-mixed Unique Dual Index (UDI) primers that can be used to barcode any library containing TruSeq<sup>®</sup> adapters. Indexes in the Zymo-Seq UDI Primer Set (Indexes 1-12) are dispensed in 1.5 mL tubes (Cat. No. D3008), and the Zymo-Seq UDI Primer Plate (Indexes 1-96) are dispensed in single-use foil-sealed 96-well plates (Ca. No. D3096). Indexed libraries are compatible with any Illumina<sup>®</sup> sequencer. ",
			"handle": "/products/dsdna-shearase-plus",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/d3008_d3096_zymo-seq_udi_primer_set_Indexes_1-96.png?v=1628532421&width=600",
			"generalIndex": "998",
			"id": "dsdna-shearase-plus",
			"tags": [
				"5mc",
				"methylation:-whole-genome",
				"methylation:-reduced-representation",
				"bisulfite",
				"whole-genome-dna-seq",
				"12-preps",
				"96-preps",
			],
			filters: []
		},
	}
}